export default __webpack_public_path__ + "static/media/1963-mobile.6a43866e.jpg";